import { Fragment } from 'react';

import cx from 'classnames';

import LocationDropdown from '../../../SearchBar/LocationDropdown';
import VendorDropdown from '../../../SearchBar/VendorDropdown';
import { useVendorSearchNavigation } from '../../contexts/VendorSearchNavigationContext';
import { useSRPSearchBarContext } from './SRPSearchBarContext';

// This is a hot mess of coupled code.
import styles from '../../../SearchBar/SearchBar.module.less';

type SearchDropdownProps = {
  allowInteractiveSearch: boolean;
  shouldCloseDropdown?: boolean;
  className?: string;
};

export const SRPSearchBarDropdowns = ({
  allowInteractiveSearch,
  shouldCloseDropdown,
  className,
}: SearchDropdownProps) => {
  const {
    selectedLocation,
    updateSelectedLocation,
    locationDropdownInput,
    setLocationDropdownInput,
    nextTaxonomySearch,
    setNextTaxonomySearch,
    vendorDropdownInput,
    setVendorDropdownInput,
  } = useSRPSearchBarContext();
  const { navigateToSrp } = useVendorSearchNavigation();

  return (
    <Fragment>
      <div className={cx(styles.dropdownWrapper, className)}>
        <LocationDropdown
          selectedLocation={selectedLocation}
          updateSelectedLocation={updateSelectedLocation}
          inputString={locationDropdownInput}
          setInputString={setLocationDropdownInput}
          selectedTaxonomyNode={nextTaxonomySearch}
          navigateToSrp={navigateToSrp}
          allowInteractiveSearch={allowInteractiveSearch}
          shouldCloseDropdown={shouldCloseDropdown}
        />
      </div>
      <div className={cx(styles.dropdownWrapper, className)}>
        <VendorDropdown
          selectedTaxonomyNode={nextTaxonomySearch}
          setSelectedTaxonomyNode={setNextTaxonomySearch}
          inputString={vendorDropdownInput}
          setInputString={setVendorDropdownInput}
          navigateToSrp={navigateToSrp}
          selectedLocation={selectedLocation}
          allowInteractiveSearch={allowInteractiveSearch}
          shouldCloseDropdown={shouldCloseDropdown}
        />
      </div>
    </Fragment>
  );
};
